import * as Scrivito from "scrivito";

const Redirect = Scrivito.provideObjClass("Redirect", {
  attributes: {
    title: "string",
    link: "link",
    navigationIcon: "string",
    openInUi: ["enum", { values: ["yes", "no"] }],
    description: "string",
    shortDescription: "string",
  },
});

export default Redirect;
